import React from 'react';
import {
    Alert,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    Stack,
    Typography
} from '@mui/material';
import PropTypes from 'prop-types';
import AdmicityDialog from '../../../../shared-components/AdmicityDialog';
import {GROUP_MEMBERS_TYPE} from '../../../../constants/GroupMembersType';

const ExportMembersTypeDialog = ({
    open,
    value,
    onClose,
    onChange,
    onContinue
}) => (
    <AdmicityDialog
        open={open}
        handleClose={onClose}
        title="Export to Group"
        actions={[
            {
                label: 'Cancel',
                onClick: onClose
            },
            {
                label: 'Continue',
                onClick: onContinue
            }
        ]}
    >
        <Stack spacing={2} sx={{paddingTop: 1}}>
            <Alert severity="info">
                <Stack spacing={0.5}>
                    <Typography variant="body2">
                        This form has both a student context and an employee assignee.
                    </Typography>
                    <Typography variant="body2">
                        Choose which people should be added to the group.
                    </Typography>
                    <Typography variant="body2">
                        This does not preserve employee-student pairings.
                    </Typography>
                </Stack>
            </Alert>
            <FormControl component="fieldset">
                <RadioGroup
                    name="export-members-type"
                    value={String(value)}
                    onChange={(event) => onChange(Number(event.target.value))}
                >
                    <FormControlLabel
                        value={String(GROUP_MEMBERS_TYPE.employee)}
                        control={<Radio/>}
                        label="Export employees"
                    />
                    <FormControlLabel
                        value={String(GROUP_MEMBERS_TYPE.students)}
                        control={<Radio/>}
                        label="Export students"
                    />
                </RadioGroup>
            </FormControl>
        </Stack>
    </AdmicityDialog>
);

ExportMembersTypeDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    value: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onContinue: PropTypes.func.isRequired,
};

export default ExportMembersTypeDialog;
